(function () {
  'use strict';

  var API  = 'https://jewelyecom.in/alankar/api/product.php';
  var SHOP = window.Shopify ? window.Shopify.shop : '';
  var pidEl = document.getElementById('agdProductId');
  var PID  = pidEl ? parseInt(pidEl.value, 10) : 0;

  function el(id)  { return document.getElementById(id); }
  function fmt(n)  { return Number(n).toLocaleString('en-IN', {minimumFractionDigits:2,maximumFractionDigits:2}); }
  function set(id, val) { var e = el(id); if (e) e.textContent = val; }
  function addRow(tbody, cells, cls) {
    var tr = document.createElement('tr');
    if (cls) tr.className = cls;
    cells.forEach(function(c) {
      var td = document.createElement('td');
      td.textContent = c;
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  }
  function addRowHtml(tbody, cells, cls) {
    var tr = document.createElement('tr');
    if (cls) tr.className = cls;
    cells.forEach(function(c, i) {
      var td = document.createElement('td');
      if (i === 2) { td.innerHTML = c; } else { td.textContent = c; }
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  }
  // Renders "Rs.<new> Rs.<old (struck through)>" — same pattern already used for the Final Price row
  function struckAmount(newVal, oldVal) {
    return 'Rs.' + fmt(newVal) + ' <s style="color:#999;font-size:.85em;margin-left:6px">Rs.' + fmt(oldVal) + '</s>';
  }

  /* DB FETCH */
  if (PID) {
    fetch(API + '?shopify_id=' + PID + '&shop=' + encodeURIComponent(SHOP))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.found || !data.product) return;
        var p = data.product;

        set('agdGrossWeight', p.gross_display || '—');
        set('agdNetWeight',   p.net_display   || '—');
        set('agdPurity',      p.purity_short  || '—');

        var dSpec = el('agdDiamondSpec');
        if (p.has_diamond && p.diamonds && p.diamonds.length > 0) {
          if (dSpec) dSpec.style.display = 'flex';
          var totalCt = p.diamonds.reduce(function(s, d) { return s + d.carat_each; }, 0);
          set('agdDiamond', totalCt.toFixed(3) + ' ct');
        } else {
          if (dSpec) dSpec.style.display = 'none';
        }

        if (p.gold_rate > 0) {
          var rRow = el('agdGoldRateRow');
          if (rRow) rRow.style.display = 'flex';
          set('agdGoldRateVal', p.gold_rate_display + ' (' + p.purity_short + ')');
        }

        // Price display with discount support
        var hasDiscount = p.discounted_price && p.compare_at_price && parseFloat(p.discounted_price) < parseFloat(p.compare_at_price);
        var priceBox = el('agdPrice');
        if (priceBox) {
          if (hasDiscount) {
            priceBox.innerHTML = '<span class="agd-price-current">Rs.' + fmt(p.discounted_price) + '</span>'
              + ' <s class="agd-price-compare" style="color:#999;font-size:.8em;margin-left:8px">Rs.' + fmt(p.compare_at_price) + '</s>';
          } else {
            priceBox.innerHTML = '<span>Rs.' + fmt(p.final_price) + '</span>';
          }
        }

        // Summary table
        set('bPurity',  p.purity_short  || '—');
        set('bNet',     p.net_display   || '—');
        set('bGross',   p.gross_display || '—');

        var bPriceEl = el('bPrice');
        if (bPriceEl) {
          if (hasDiscount) {
            bPriceEl.innerHTML = struckAmount(p.discounted_price, p.compare_at_price);
          } else {
            bPriceEl.textContent = p.final_price_display || ('Rs.' + fmt(p.final_price));
          }
        }

        if (p.has_diamond && p.diamonds && p.diamonds.length > 0) {
          var totalCt2 = p.diamonds.reduce(function(s, d) { return s + d.carat_each; }, 0);
          set('bDiamond', totalCt2.toFixed(4) + ' ct');
        } else {
          set('bDiamond', '—');
        }

        // Detailed breakdown
        var tbody = el('agdDetailTbody');
        if (!tbody) return;
        tbody.innerHTML = '';

        if (p.metal_cost > 0) {
          var deductions = [];
          if (p.less_weight  > 0) deductions.push('Less ' + Number(p.less_weight).toFixed(3) + 'g');
          if (p.stone_weight > 0) deductions.push('Stone ' + Number(p.stone_weight).toFixed(3) + 'g');
          if (p.bead_weight  > 0) deductions.push('Beads ' + Number(p.bead_weight).toFixed(3) + 'g');
          var weightCalc;
          if (deductions.length > 0) {
            weightCalc = 'Gross ' + (p.gross_display || '') + ' - ' + deductions.join(' - ') + ' = Net ' + (p.net_display || '') + ' x ' + (p.gold_rate_display || '');
          } else {
            weightCalc = (p.net_display || '') + ' x ' + (p.gold_rate_display || '');
          }
          // Metal cost itself is never discounted — always shown plain
          addRow(tbody, [p.purity + ' Metal Cost', weightCalc, 'Rs.' + fmt(p.metal_cost)]);
        }

        // Diamond lines — strike original, show discounted, per diamond
        if (p.has_diamond && p.diamonds && p.diamonds.length > 0) {
          p.diamonds.forEach(function(d) {
            if (d.cost > 0) {
              var diamondDiscounted = p.discount_active && d.discounted_cost != null && d.discounted_cost < d.cost;
              var dRateForCalc = diamondDiscounted ? d.discounted_rate : d.rate;
              var dRateDisplay = 'Rs.' + fmt(dRateForCalc) + '/ct';
              var dCalc = d.qty > 1
                ? d.carat_each + ' ct x ' + d.qty + ' pcs @ ' + dRateDisplay
                : d.carat_each + ' ct @ ' + dRateDisplay;

              if (diamondDiscounted) {
                addRowHtml(tbody, [d.label, dCalc, struckAmount(d.discounted_cost, d.cost)]);
              } else {
                addRow(tbody, [d.label, dCalc, 'Rs.' + fmt(d.cost)]);
              }
            }
          });
        }

        // Making Charges — strike original labour%/amount, show discounted (flat or reduced %)
        if (p.labour_amount > 0) {
          var labourDiscounted = p.discount_active && p.discounted && p.discounted.labour_amount < p.labour_amount;
          if (labourDiscounted) {
            var labourCalc = p.discounted.labour_percent + '% of metal cost';
            addRowHtml(tbody, ['Making Charges', labourCalc, struckAmount(p.discounted.labour_amount, p.labour_amount)]);
          } else {
            addRow(tbody, ['Making Charges', (p.labour_percent || 0) + '% of metal cost', 'Rs.' + fmt(p.labour_amount)]);
          }
        }

        if (p.stone_cost > 0)     addRow(tbody, ['Stone Cost', '—', 'Rs.' + fmt(p.stone_cost)]);
        if (p.extra_charges > 0)  addRow(tbody, [p.extra_charges_label || 'Extra Charges', '—', 'Rs.' + fmt(p.extra_charges)]);

        // Sub Total — strike original, show discounted total when either labour or diamond discount applied
        if (p.sub_total > 0) {
          var subDiscounted = p.discount_active && p.discounted && p.discounted.sub_total < p.sub_total;
          if (subDiscounted) {
            addRowHtml(tbody, ['Sub Total', '—', struckAmount(p.discounted.sub_total, p.sub_total)]);
          } else {
            addRow(tbody, ['Sub Total', '—', 'Rs.' + fmt(p.sub_total)]);
          }
        }

        // GST — recalculated off the (possibly discounted) sub-total, strike original if it changed
        if (p.gst_amount > 0) {
          var gstDiscounted = p.discount_active && p.discounted && p.discounted.gst_amount < p.gst_amount;
          if (gstDiscounted) {
            addRowHtml(tbody, ['GST (' + (p.gst_rate || 3) + '%)', '—', struckAmount(p.discounted.gst_amount, p.gst_amount)]);
          } else {
            addRow(tbody, ['GST (' + (p.gst_rate || 3) + '%)', '—', 'Rs.' + fmt(p.gst_amount)]);
          }
        }

        if (hasDiscount) {
          addRowHtml(tbody, [
            'Final Price',
            'Incl. all taxes & charges',
            struckAmount(p.discounted_price, p.compare_at_price)
          ], 'agd-total-row');
        } else {
          if (p.final_price > 0) {
            addRow(tbody, ['Final Price', 'Incl. all taxes & charges', p.final_price_display || ('Rs.' + fmt(p.final_price))], 'agd-total-row');
          }
        }
      })
      .catch(function(err) { console.warn('AGD DB fetch failed:', err); });
  }

  document.addEventListener('DOMContentLoaded', function() {

    /* AJAX FORM SUBMIT */
    document.querySelectorAll('.agd-modal-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var originalText = btn.textContent;
        btn.textContent = 'Submitting...';
        btn.disabled = true;
        var formData = new FormData(form);
        fetch('/contact', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function() {
          var modalId = form.closest('.agd-modal').id;
          form.innerHTML = '<div class="agd-form-success">'
            + '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#d4b76d" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10" stroke="#d4b76d" stroke-width="2"/></svg>'
            + '<h3>Request Submitted!</h3>'
            + '<p>Thank you. Our team will contact you shortly to confirm your appointment.</p>'
            + '<button type="button" class="agd-cta-btn agd-cta-primary agd-full" style="margin-top:20px;" onclick="agdCloseModal(\'' + modalId + '\')">Close</button>'
            + '</div>';
        })
        .catch(function() {
          btn.textContent = originalText;
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
      });
    });

    /* GALLERY */
    var thumbBtns   = document.querySelectorAll('.agd-thumb-btn');
    var mainImg     = el('agdMainImg');
    var galleryImgs = [];

    thumbBtns.forEach(function(btn, i) {
      btn.dataset.index = i;
      galleryImgs.push(btn.dataset.src);
      btn.addEventListener('click', function() {
        thumbBtns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (mainImg) {
          mainImg.style.opacity = '0';
          mainImg.src = this.dataset.src;
          mainImg.onload = function() { mainImg.style.transition = 'opacity .3s'; mainImg.style.opacity = '1'; };
        }
      });
    });
    if (!galleryImgs.length && mainImg) galleryImgs.push(mainImg.src);

    /* ACCORDION */
    var accBtn  = el('agdAccBtn');
    var accBody = el('agdAccBody');
    if (accBtn && accBody) {
      accBtn.addEventListener('click', function() {
        var exp = accBtn.getAttribute('aria-expanded') === 'true';
        accBtn.setAttribute('aria-expanded', String(!exp));
        if (exp) { accBody.setAttribute('hidden', ''); } else { accBody.removeAttribute('hidden'); }
      });
    }

    /* RELATED SLIDER */
    var track  = el('agdRelTrack');
    var slides = track ? Array.from(track.querySelectorAll('.agd-rel-slide')) : [];
    var cur    = 0;
    function getVis() { return window.innerWidth < 768 ? 2 : window.innerWidth < 1024 ? 3 : 4; }
    function updateRel() { if (!slides.length) return; var w = slides[0].offsetWidth + 20; track.style.transform = 'translateX(-' + (cur * w) + 'px)'; }
    var prevBtn = el('agdRelPrev');
    var nextBtn = el('agdRelNext');
    if (prevBtn) prevBtn.addEventListener('click', function() { if (cur > 0) { cur--; updateRel(); } });
    if (nextBtn) nextBtn.addEventListener('click', function() { var m = slides.length - getVis(); if (cur < m) { cur++; updateRel(); } });

    /* LIGHTBOX */
    var lb      = el('agdLightbox');
    var lbImg   = el('agdLightboxImg');
    var lbClose = el('agdLightboxClose');
    var lbPrev  = el('agdLightboxPrev');
    var lbNext  = el('agdLightboxNext');
    var lbIdx   = 0;

    function openLb(idx) {
      lbIdx = idx;
      if (lbImg) lbImg.src = galleryImgs[lbIdx];
      if (lb) lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      updateLbNav();
    }
    function closeLb() {
      if (lb) lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    function updateLbNav() {
      if (lbPrev) lbPrev.style.display = lbIdx === 0 ? 'none' : 'flex';
      if (lbNext) lbNext.style.display = lbIdx === galleryImgs.length - 1 ? 'none' : 'flex';
    }

    if (mainImg) mainImg.addEventListener('click', function() {
      var a = document.querySelector('.agd-thumb-btn.active');
      openLb(a ? parseInt(a.dataset.index || 0, 10) : 0);
    });
    if (lbClose) lbClose.addEventListener('click', closeLb);
    if (lb) lb.addEventListener('click', function(e) { if (e.target === lb) closeLb(); });
    if (lbPrev) lbPrev.addEventListener('click', function() {
      if (lbIdx > 0) { lbIdx--; if (lbImg) lbImg.src = galleryImgs[lbIdx]; updateLbNav(); }
    });
    if (lbNext) lbNext.addEventListener('click', function() {
      if (lbIdx < galleryImgs.length - 1) { lbIdx++; if (lbImg) lbImg.src = galleryImgs[lbIdx]; updateLbNav(); }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeLb();
        agdCloseModal('agdVisitModal');
        agdCloseModal('agdVideoModal');
      }
      if (lb && !lb.hasAttribute('hidden')) {
        if (e.key === 'ArrowLeft' && lbIdx > 0) { lbIdx--; if (lbImg) lbImg.src = galleryImgs[lbIdx]; updateLbNav(); }
        if (e.key === 'ArrowRight' && lbIdx < galleryImgs.length - 1) { lbIdx++; if (lbImg) lbImg.src = galleryImgs[lbIdx]; updateLbNav(); }
      }
    });

  });

  window.agdOpenModal  = function(id) { var m = document.getElementById(id); if (m) { m.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; } };
  window.agdCloseModal = function(id) { var m = document.getElementById(id); if (m) { m.setAttribute('hidden', ''); document.body.style.overflow = ''; } };

})();
(function(){
  const track = document.getElementById('agdGalleryTrack');
  const slides = track.querySelectorAll('.agd-gallery-slide');
  let idx = 0;
  function go(i){
    idx = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${idx * 100}%)`;
    document.querySelectorAll('.agd-thumb-btn').forEach((b,n)=>b.classList.toggle('active', n===idx));
  }
  document.getElementById('agdGalleryPrev').onclick = () => go(idx-1);
  document.getElementById('agdGalleryNext').onclick = () => go(idx+1);
  document.querySelectorAll('.agd-thumb-btn').forEach(btn=>{
    btn.addEventListener('click', ()=> go(+btn.dataset.index));
  });
  // swipe
  let startX=0;
  track.addEventListener('touchstart', e=> startX = e.touches[0].clientX, {passive:true});
  track.addEventListener('touchend', e=>{
    const diff = e.changedTouches[0].clientX - startX;
    if (Math.abs(diff) > 40) go(diff < 0 ? idx+1 : idx-1);
  }, {passive:true});
})();